import { Box, DialogTitle, IconButton } from "@mui/material"
import { useRevalidator } from "react-router-dom";
import { dialogClose } from "."
import { Close as CloseIcon } from '@mui/icons-material';
import { useSpaceUserV2Store } from '@/store';

interface DialogTitleProp {
    title: string;
    isRevalidate?: boolean
    dialogId?: string;
    isDraggable?: boolean;
}
const DialogTitleBox = (props: DialogTitleProp) => {
    const { title, isRevalidate = false, dialogId = '', isDraggable = false } = props
    const { revalidate } = useRevalidator()
    const { grade_name } = useSpaceUserV2Store();
    const isSodomall = grade_name === '소도몰';
    
    return (
        <Box
            className="flex items-center justify-between"
            sx={{ backgroundColor: isSodomall ? '#363bc2' : '#ff6aac', cursor: !!isDraggable ? 'move' : undefined }}
            id={`${dialogId}-draggable-title`}
        >
            <DialogTitle sx={{ color: 'white !important' }}>{title}</DialogTitle>
            <IconButton
                sx={{ mr: 2 }}
                color="white"
                onClick={() => {
                    isRevalidate && revalidate()
                    dialogClose(!!dialogId ? dialogId : '')
                }}
            >
                <CloseIcon />
            </IconButton>
        </Box>
    )
}

export default DialogTitleBox